import { useRef } from "react";
import nanoid from "nanoid";

export function useElementId(id: string): React.RefObject<string> {
    return useRef<string>(id || nanoid());
}
